import React from "react";
import { leaf, logo_black_bg, smallFlower } from "../../assets";
import { BsBookmarkPlus } from "react-icons/bs";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LazyLoadImage } from "react-lazy-load-image-component";

const BeautyTreatment = ({
  mainTitle,
  title,
  subTitle,
  f1,
  f2,
  f3,
  f1Title,
  f2Title,
  f3Title,
  mainLogo,
  mainBanner,
  id,
  toLink,
}) => {
  const navigate = useNavigate();

  return (
    <motion.div
      className="beautyTreatmentCard"
      id={id}
      whileInView={{ y: [50, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
    >
      <div className="leftCOL">
        <h1>
          {mainTitle} <img src={leaf} alt="" className="headingLeaf" />
        </h1>

        <p className="title">{title}</p>
        <small className="subtitle">{subTitle}</small>

        <div className="features">
          <div className="feature">
            <img src={smallFlower} alt="" />
            <p>{f1Title}</p>

            <div>
              <div className="point"></div>
              <small>Improvements</small>
            </div>
            <div>
              <div className="point"></div>
              <small>Corrections</small>
            </div>
          </div>
          <div className="feature">
            <img src={smallFlower} alt="" />
            <p>{f2Title}</p>

            <div>
              <div className="point"></div>
              <small>Improvements</small>
            </div>
            <div>
              <div className="point"></div>
              <small>Corrections</small>
            </div>
          </div>
          <div className="feature">
            <img src={smallFlower} alt="" />
            <p>{f3Title}</p>

            <div>
              <div className="point"></div>
              <small>Improvements</small>
            </div>
            <div>
              <div className="point"></div>
              <small>Corrections</small>
            </div>
          </div>
        </div>

        <div className="btn-grp">
          <button
            className="highLight firstHigh"
            onClick={() => navigate("/appointment")}
          >
            <p>Book Appointment</p>
          </button>

          <button className="highLight">
            <Link className="linkBtn" to={toLink}>
              <AiOutlineUnorderedList className="io" />
              <p>View More</p>
            </Link>
          </button>
        </div>
      </div>
      <div className="rightCOL">
        <LazyLoadImage effect="blur" src={mainBanner} alt="" className="treatmentBanner" />
      </div>

    </motion.div>
  );
};

export default BeautyTreatment;
